import { useState } from "react"

import InputText from "../../components/InputText";

import "./style.css"


const init_form = {
    id: '',
    pw: '',
    save: false
}


function MySpace() {
    const [formLogin, setFormLogin] = useState(init_form);

    return (
        <div className="page page_mySpace">
            <div className="ctn_anim">
                <span>My Space</span>
                <p>Accédez des maintenant à l'interface graphique de vos sites pour modifier les couleurs, typographies, marges ...</p>
            </div>

            <form>
                <div className="grid">
                    <InputText label='Id :' placeholder='webSpace' value={formLogin.lastname} setValue={setFormLogin} field='id' />
                    <InputText label='Password :' placeholder='**************' value={formLogin.firstname} setValue={setFormLogin} field='pw' />
                </div>

                <div className="save" onClick={() => setFormLogin({ ...formLogin, save: !formLogin.save })}>
                    <i className='checkBox'>{formLogin.save && 'x'}</i>
                    <p>Se souvenir de moi</p>
                </div>

                {/* <p className='msg_error'>Id ou Password incorrecte</p> */}

                <button
                    type="submit"
                    className='btn_submit'
                >Confirmer</button>
            </form>
        </div>
    )
}

export default MySpace;